import { render, staticRenderFns } from "./XzdListPage.vue?vue&type=template&id=4b2c7588&scoped=true&"
import script from "./XzdListPage.vue?vue&type=script&lang=js&"
export * from "./XzdListPage.vue?vue&type=script&lang=js&"
import style0 from "./XzdListPage.vue?vue&type=style&index=0&id=4b2c7588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c7588",
  null
  
)

export default component.exports